import React from "react";
import { ourValues } from "../../utils/constants/Team";
import Fade from "react-reveal/Fade";
import CustomNextImage from "../common/CustomNextImage";

const OurValues = () => {
  return (
    <section>
      <Fade bottom>
        <h6 className="text-[24px] font-lexend font-semibold text-center lg:text-[40px]">
          Our Values
        </h6>
      </Fade>
      <div className="mt-8 md:flex md:gap-x-5 lg:gap-x-11">
        {ourValues.map((item) => {
          return (
            <div
              key={item?.title}
              className="group relative cursor-pointer mt-4 w-full rounded-xl p-4 hover-float hover:bg-gradient-to-b hover:from-[#2e0a4f] hover:via-[#200737] hover:to-[#160526] hover:border hover:!border-[#472f5d] lg:mt-0 lg:p-6"
              style={{
                backgroundColor: item.bgColor,
                border: `1px solid ${item.borderColor}`,
              }}
            >
              <div className="absolute top-0 left-5">{item?.bgTopElement}</div>
              <div className="absolute bottom-0 right-5">
                {item?.bgBottomElement}
              </div>
              <div>
                <CustomNextImage
                  src={item?.icon}
                  alt={item?.title}
                  width={200}
                  height={200}
                  className="mx-auto w-[80px] md:w-[70px] lg:w-[100px] transform transition-transform duration-700 group-hover:scale-[1.15]"
                />
              </div>
              <div className="mt-4 md:mt-6">
                <h6 className="font-lexend font-semibold text-[20px] text-center md:text-[18px] lg:text-[24px]">
                  {item?.title}
                </h6>
                <p className="font-lexend text-[12px] leading-[14px] mt-4 text-[#B8B8B8] text-center md:mt-2 lg:mt-4 lg:text-[14px] lg:leading-[18px]">
                  {item?.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default OurValues;
